export default __webpack_public_path__ + "app/images/a7fdb5b1d66726fd67948aa05cfac8b6.svg";